"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var qr_code_component_1 = require("../../../../../controls/qr-code/qr-code.component");
var qr_code_module_1 = require("../../../../../controls/qr-code/qr-code.module");
var OverviewCustomComponentProviderImplService = /** @class */ (function () {
    function OverviewCustomComponentProviderImplService() {
    }
    OverviewCustomComponentProviderImplService.prototype.getCustomComponents = function (category, rootCategory, cardType) {
        var qrCodeComponent = {
            componentSelector: 'ejustice-qr-code',
            title: 'ejustice_qr_code',
            componentInputs: { qrOptions: { scale: 2 } },
            component: qr_code_component_1.QRCodeComponent,
            participants: [],
            moduleLoaderFunction: function () { return qr_code_module_1.QRCodeModule; }
        };
        return Observable_1.Observable.of([qrCodeComponent]);
    };
    OverviewCustomComponentProviderImplService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], OverviewCustomComponentProviderImplService);
    return OverviewCustomComponentProviderImplService;
}());
exports.OverviewCustomComponentProviderImplService = OverviewCustomComponentProviderImplService;
//# sourceMappingURL=overview-custom-component-provider-impl.service.js.map